import styled from 'styled-components'; // Fixing the build
import theme from 'theme';

import { ModalContent, ModalFooter, ModalGrid, ModalHeader } from 'components/GlobalModal';
import KoalaIconButton from 'koala/components/IconButton';
import React from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { setGlobalModalContent } from 'state/actions/globalUIActions';
import KoalaButton from 'koala/components/Button';
import { useTranslation } from 'react-i18next';
import { Base64 } from 'js-base64';

const Container = styled.div`
  h3 {
    margin: ${theme.spacing.x3} 0 ${theme.spacing.x1} 0;
    &:first-of-type {
      margin-top: 0;
    }
  }
`;

function ConnectMonday() {
  const dispatch = useDispatch();
  const currentWorkspace = useSelector((state: any) => state.session.currentWorkspace, shallowEqual);
  const { t } = useTranslation();
  const translationKey = 'modals.connectMonday';

  const handleCancel = (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch(setGlobalModalContent(''));
  };

  const mondayRedirectURL = `https://${process.env.REACT_APP_DOMAIN}/install/monday`;
  const mondayScope = 'boards:read workspaces:read';

  // tabilityRedirect is the redirection to use after the app is installed
  const tabilityRedirect = `${currentWorkspace.url}/settings/integrations`;
  const oauthState = {
    redirect_after: tabilityRedirect,
    slug: currentWorkspace.slug,
    currentDate: new Date(),
  };
  const state = Base64.encode(JSON.stringify(oauthState));

  const mondayOAuthURL =
    `https://auth.monday.com/oauth2/authorize` +
    `?client_id=${process.env.REACT_APP_MONDAY_CLIENT_ID}` +
    `&redirect_uri=${encodeURIComponent(mondayRedirectURL)}` +
    `&scope=${encodeURIComponent(mondayScope)}&state=${state}`;

  return (
    <ModalGrid>
      <ModalHeader>
        <h2>{t(`${translationKey}.title`)}</h2>
        <KoalaIconButton onClick={handleCancel} iconName="close" />
      </ModalHeader>
      <ModalContent>
        <Container>
          <h3>1. Install the Tability Monday app in your Monday workspace</h3>
          <p>You need first to install the Tability Monday app in your workspace.</p>
          <p>
            <a
              href={`https://auth.monday.com/oauth2/authorize?client_id=${process.env.REACT_APP_MONDAY_CLIENT_ID}&response_type=install`}
              target="_blank"
              rel="noopener noreferrer"
              className="button primary"
            >
              Install Tability Monday app
            </a>
          </p>
          <h3>2. Connect your Monday workspace to Tability</h3>
          <p>Once the app is installed, you can connect it to your Monday workspace by clicking the button below.</p>
          <p>
            <a href={mondayOAuthURL} className="button primary">
              Connect Tability Monday app
            </a>
          </p>
        </Container>
      </ModalContent>
      <ModalFooter>
        <KoalaButton onClick={handleCancel} appearance="secondary">
          {t('shared.close')}
        </KoalaButton>
      </ModalFooter>
    </ModalGrid>
  );
}

export default ConnectMonday;
